import React from "react";

import "./styles/videoEmbed.css";

// Accepts a YouTube, Vimeo, or direct video (mp4/webm) URL and renders it
// responsively. Set an article's `video` field to any of these.
function resolve(url) {
	const yt = url.match(
		/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]+)/
	);
	if (yt) {
		return { kind: "iframe", src: `https://www.youtube.com/embed/${yt[1]}` };
	}
	const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
	if (vimeo) {
		return {
			kind: "iframe",
			src: `https://player.vimeo.com/video/${vimeo[1]}`,
		};
	}
	return { kind: "file", src: url };
}

const VideoEmbed = ({ url }) => {
	if (!url) return null;
	const video = resolve(url);

	return (
		<div className="video-embed">
			{video.kind === "iframe" ? (
				<div className="video-embed-frame">
					<iframe
						src={video.src}
						title="Embedded video"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					/>
				</div>
			) : (
				<video
					className="video-embed-native"
					controls
					src={video.src}
				/>
			)}
		</div>
	);
};

export default VideoEmbed;
